import {
  Action,
  ActionType,
  CoverageSelectorCoverageType,
  CoverageSelectorSelectedValues,
  PlanType,
} from "../../@types";

const planTypeMap: Record<CoverageSelectorCoverageType, PlanType | undefined> =
  {
    [CoverageSelectorCoverageType.MAPD]: PlanType.MAPD,
    [CoverageSelectorCoverageType.PDP]: PlanType.PDP,
    [CoverageSelectorCoverageType.PDPAndMedigap]: PlanType.PDP,
    [CoverageSelectorCoverageType.MedigapPolicy]: undefined,
    [CoverageSelectorCoverageType.learnMore]: undefined,
  };

export const updateStates = (
  coverageSelectorValues: CoverageSelectorSelectedValues,
  dispatch: React.Dispatch<Action>
): void => {
  dispatch({
    type: ActionType.UPDATE_VIEW_MEDIGAP,
    payload:
      coverageSelectorValues.coverageType ===
      CoverageSelectorCoverageType.PDPAndMedigap,
  });
  dispatch({
    type: ActionType.UPDATE_YEAR,
    payload: coverageSelectorValues.coverageYear.toString(),
  });
  dispatch({
    type: ActionType.UPDATE_COUNTY,
    payload: coverageSelectorValues.county,
  });
  dispatch({
    type: ActionType.UPDATE_FIPS,
    payload: coverageSelectorValues.county?.fips,
  });
  dispatch({
    type: ActionType.UPDATE_ZIPCODE,
    payload: coverageSelectorValues.zipcode,
  });
  dispatch({
    type: ActionType.UPDATE_PHARMACY_ADDRESS,
    payload: "",
  });

  if (coverageSelectorValues.coverageType) {
    const planType = planTypeMap[coverageSelectorValues.coverageType];
    if (planType) {
      dispatch({
        type: ActionType.UPDATE_PLAN_TYPE,
        payload: planType,
      });
    }
  }
};
